module.exports = __webpack_public_path__ + "img/xrpl-odl-rosetta.741e2d19.gif";